
export enum UserAffiliatePayoutStatus {
    NOT_SET = "NOT_SET",
    PENDING = "PENDING",
    PROCESSING = "PROCESSING",
    COMPLETED = "COMPLETED",
    UNDER_REVIEW = "UNDER_REVIEW"
}
